import { Component, OnInit } from '@angular/core';
import { HelperService } from 'src/services/helperService';

@Component({
    selector: 'app-sessionFailed',
    templateUrl: './sessionFailed.component.html',
    styleUrls: ['./sessionFailed.component.sass'],
    standalone: false
})
export class sessionFailedComponent implements OnInit {
  
  constructor(public helperService: HelperService) { }

  ngOnInit(): void {
  }
  onClick() {    
  }

}
